import { render, staticRenderFns } from "./ReferenceUploadListItem.vue?vue&type=template&id=61895f7b&scoped=true&"
import script from "./ReferenceUploadListItem.vue?vue&type=script&lang=js&"
export * from "./ReferenceUploadListItem.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceUploadListItem.vue?vue&type=style&index=0&id=61895f7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61895f7b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VProgressCircular,VSpacer})
